<div class="login-container">
  <div class="login-card">
    <!-- Header -->
    <div class="card-header">
      <div class="icon-container">
        <i class="fas fa-user-circle"></i>
      </div>
      <h1>Bienvenido</h1>
      <p>Tu sesión ha sido cerrada correctamente. Inicia sesión para continuar.</p>
    </div>

    <!-- Content -->
    <div class="card-content">
      <div class="contact-box">
        <h2>Soporte APSER</h2>
        <div class="contact-info">
          <a href="mailto:soporte@apser.es" class="contact-link">
            <i class="fas fa-envelope"></i>
            soporte@apser.es
          </a>
        </div>
      </div>
      <p class="help-text">
        Si tienes problemas para acceder, contacta con nuestro equipo de soporte.
      </p>
    </div>

    <!-- Footer -->
    <div class="card-footer">
      <button (click)="login()" class="home-button">
        <i class="fas fa-sign-in-alt"></i>
        Iniciar sesión
      </button>
    </div>
  </div>
</div>
